export * from './lib/consultation-data-access.module';
export * as ConsultationActions from './lib/+state/consultation.actions';
export * as ConsultationSelectors from './lib/+state/consultation.selectors';